import { Trans } from "@lingui/macro";
import { Box, Typography, Button } from "@mui/material";
import { SlidingDrawer } from "@WahooFitness/redesignr";
import { useConfigContext } from "@WahooFitness/wahoo-offline-mfe";

function DeleteCustomPageDrawer({
  pageName,
  handleCloseDrawer,
  handleDelete,
  open,
}: {
  pageName?: string;
  handleCloseDrawer: () => void;
  handleDelete: () => void;
  open: boolean;
}) {
  const { globalBottomPadding, platform } = useConfigContext();

  return (
    <SlidingDrawer
      platform={platform}
      globalBottomPadding={globalBottomPadding}
      open={open}
      title=""
      hidePuller
      hideDivider
      hideHeader
      elevation={4}
      handleOpen={() => {}}
      handleClose={handleCloseDrawer}
    >
      <Box display="flex" flexDirection="column">
        <Box display="flex" flexDirection="column" gap={1} alignItems="center" px={4} pb={3} pt={4}>
          <Typography variant="prose-lg-medium" textAlign="center">
            <Trans>Delete &quot;{pageName}&quot;?</Trans>
          </Typography>
          <Typography variant="prose-base" textAlign="center">
            <Trans>
              Deleting will remove this page from all devices that use this Workout Profile. <br />
              This cannot be undone.
            </Trans>
          </Typography>
        </Box>

        <Box display="flex" flexDirection="row" p={3} gap={1.5}>
          <Button variant="outlined" size="large" fullWidth onClick={handleCloseDrawer}>
            <Trans>Keep</Trans>
          </Button>
          <Button color="error" variant="outlined" size="large" fullWidth onClick={handleDelete}>
            <Trans>Delete</Trans>
          </Button>
        </Box>
      </Box>
    </SlidingDrawer>
  );
}

export default DeleteCustomPageDrawer;
